import styled from "styled-components";
import { toVWDesktop, toVWMobile, toREM } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import ScrollContainer from "react-indiana-drag-scroll";

export const StyledContainer = styled(ScrollContainer)`
  direction: ltr;
  padding-bottom: ${toVWMobile(84)}vw;
  display: flex;
  width: 100vw;
  gap: ${toVWMobile(20)}vw;
  margin-top: ${toVWMobile(30)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${toVWDesktop(20)}vw;
    padding-bottom: ${toVWDesktop(40)}vw;
    margin-top: ${toVWDesktop(40)}vw;

    &:hover {
      cursor: grab;
    }
  }
`;

export const Container = styled.section<{ backgroundColor?: string, color?: string, cardColor?: string }>`
  background-color: ${(props) => props.backgroundColor || "#012102"};
  --color: ${(props) => props.color || "#ffffff"};
  color: var(--color);
  --card-color: ${(props) => props.cardColor || "#033305"};
  padding: ${toVWMobile(44)}vw 0;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${toVWDesktop(80)}vw 0;
  }
`;

export const Title = styled.h2`
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toREM(34)}rem;
  font-weight: 900;
  font-style: normal;
  letter-spacing: ${toREM(34 * 0.04)}rem;
  line-height: 0.94;
  padding: 0 ${toVWMobile(16)}vw;
  text-transform: uppercase;
  text-align: center;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0 ${toVWDesktop(24)}vw;
    font-size: ${toREM(56)}rem;
    letter-spacing: ${toREM(56 * 0.04)}rem;
    line-height: 0.94;
    margin: 0 auto;
  }
`;

export const Subtitle = styled.h3`
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toVWMobile(18)}vw;
  font-weight: 600;
  line-height: 1.4;
  padding-inline: ${toVWMobile(16)}vw;
  margin-top: ${toVWMobile(8)}vw;
  text-align: center;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(18)}vw;
    line-height: 1.4;
    margin-top: ${toVWDesktop(8)}vw;
    padding-inline: ${toVWDesktop(24)}vw;
  }
`;

export const QuestionCard = styled.div<{ href?: string }>`
  color: var(--color);
  background-color: var(--card-color);
  direction: ${(props) => (props.theme.isRTL ? "rtl" : "ltr")};
  min-height: ${toVWMobile(450)}vw;
  padding: ${toVWMobile(24)}vw ${toVWMobile(24)}vw 0;
  min-width: ${toVWMobile(300)}vw;
  overflow: hidden;
  text-decoration: none;
  display: block;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    min-height: ${toVWDesktop(566)}vw;
    padding: ${toVWDesktop(48)}vw ${toVWDesktop(48)}vw 0;
    min-width: ${toVWDesktop(500)}vw;
  }

  &a:hover {
    cursor: pointer;
  }

  &.with-card-offset {
    position: relative;
    bottom: ${toVWMobile(-40)}vw;

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      bottom: ${toVWDesktop(-40)}vw;
    }
  }
`;

export const QuestionTitle = styled.h3`
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toVWMobile(24)}vw;
  letter-spacing: ${toVWMobile(0.72)}vw;
  font-weight: 800;
  font-style: normal;
  line-height: 1.2;
  margin-bottom: ${toVWMobile(28)}vw;
  text-align: ${(props) => (props.theme.isRTL ? "right" : "left")};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(32)}vw;
    letter-spacing: ${toVWDesktop(32 * 0.04)}vw;
    margin-bottom: ${toVWDesktop(35)}vw;
    line-height: 1.2;
  }
`;

export const Answer = styled.p`
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toVWMobile(16)}vw;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.4;
  text-align: ${(props) => (props.theme.isRTL ? "right" : "left")};
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
  overflow: hidden;

  a {
    color: currentcolor;
    font-weight: 700;
    
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(20)}vw;
  }
`;

export const CtaWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: ${toVWMobile(40)}vw ${toVWMobile(24)}vw ${toVWMobile(40)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    align-items: center;
    padding: ${toVWDesktop(20)}vw ${toVWDesktop(24)}vw ${toVWDesktop(80)}vw;
  }
`;